export default __webpack_public_path__ + "static/media/skippedmeal@2x.8f1380ce.jpg";